import React from 'react';
import CalculusOfAlignment from '../components/CalculusOfAlignment';

function CalculusOfAlignmentPage() {
  return <CalculusOfAlignment />;
}

export default CalculusOfAlignmentPage;
